import contentObservable from './contentObservable';
import promoObservable from './promoObservable';
import { merge } from 'rxjs';

function cornerObservable(id: string, title: string) {
  return merge(promoObservable(id), contentObservable(id, title));
}

export default cornerObservable;
